import { MemberProfileShort } from 'cwp-components/CWP Sections/MemberProfile/MemberProfileShort';
import e from 'express'
import React from 'react'
import { useLocation } from 'react-router-dom';

interface ViewTeamProfilesProps { }

const ViewTeamProfiles = (props: ViewTeamProfilesProps) => {
  const location = useLocation()
  const profile = location.state?.profile

  if (!profile) return null

  return (
    <>
      <div className='p-4 h-fit bg-white text-center pt-10'>
        <h1 className='text-[#020251] text-lg font-bold mb-8'>
          These are the lawyers who work for {profile?.displayName}.
        </h1>
        <p className='text-[#405985]'>Click the View button to see more details. You can then click connect to request a booking.</p>
        <div className='p-8 flex h-full justify-center flex-wrap gap-[30px] md:justify-left'>
          {profile?.team?.members?.map((member) => (
            <MemberProfileShort profile={member} />
          ))}
        </div>
      </div>

    </>
  )
}

export default ViewTeamProfiles